import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiJava,
  DiAngularSimple,
} from "react-icons/di";
import {
  SiRedis,
  SiSpring,
  SiPostgresql,
  SiMysql,
  SiExpress,
  SiCamunda,
  SiDocker,
  SiKubernetes,
  SiHelm,
  SiTerraform,
  SiAnsible,
  SiGitlab,
  SiApachekafka,
  SiApacheairflow,
  SiElastic,
  SiDynatrace,
  SiVault,
  SiArgo,
} from "react-icons/si";
import { TbBrandAws, TbCloud } from "react-icons/tb";

const groups = [
  {
    title: "Languages & Frameworks",
    icons: [
      { Icon: DiJava, label: "Java" },
      { Icon: DiPython, label: "Python" },
      { Icon: DiNodejs, label: "Node.js" },
      { Icon: SiExpress, label: "Express" },
      { Icon: DiAngularSimple, label: "Angular" },
      { Icon: DiReact, label: "React" },
      { Icon: SiSpring, label: "Spring" },
      { Icon: DiJavascript1, label: "JavaScript" },
    ],
  },
  {
    title: "BPM & Workflow",
    icons: [{ Icon: SiCamunda, label: "Camunda" }],
  },
  {
    title: "Cloud & Infrastructure",
    icons: [
      { Icon: TbBrandAws, label: "AWS" },
      { Icon: TbCloud, label: "IBM Cloud" },
      { Icon: SiDocker, label: "Docker" },
      { Icon: SiKubernetes, label: "Kubernetes" },
      { Icon: SiHelm, label: "Helm" },
      { Icon: SiTerraform, label: "Terraform" },
      { Icon: SiAnsible, label: "Ansible" },
      { Icon: SiGitlab, label: "GitLab" },
      { Icon: SiArgo, label: "ArgoCD" },
    ],
  },
  {
    title: "Data & Messaging",
    icons: [
      { Icon: SiApachekafka, label: "Kafka" },
      { Icon: SiApacheairflow, label: "Airflow" },
      { Icon: DiMongodb, label: "MongoDB" },
      { Icon: SiMysql, label: "MySQL" },
      { Icon: SiPostgresql, label: "PostgreSQL" },
      { Icon: SiRedis, label: "Redis" },
    ],
  },
  {
    title: "Observability & Security",
    icons: [
      { Icon: SiElastic, label: "Elastic (ELK)" },
      { Icon: SiDynatrace, label: "Dynatrace" },
      { Icon: SiVault, label: "HashiCorp Vault" },
    ],
  },
];

function Techstack() {
  return (
    <>
      {groups.map((group) => (
        <div key={group.title} className="about-subgroup">
          <p className="about-subgroup-title">{group.title}</p>
          <Row style={{ justifyContent: "center", paddingBottom: "20px" }}>
            {group.icons.map(({ Icon, label }) => (
              <Col xs={4} md={2} className="tech-icons" title={label} key={label}>
                <Icon />
              </Col>
            ))}
          </Row>
        </div>
      ))}
    </>
  );
}

export default Techstack;
